import { cn } from '@/shared/utils/cn';
import { Icon } from '@/modules/Icon';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

interface ColorSwatchProps {
  /** Color en formato hexadecimal */
  color: string;
  /** Si el color está seleccionado */
  selected?: boolean;
  /** Callback cuando se hace click en el color */
  onClick?: () => void;
  /** Tamaño del swatch */
  size?: 'sm' | 'md' | 'lg';
  /** Clase personalizada */
  className?: string;
}

const sizeMap = {
  sm: 'ui-w-24 ui-h-24',
  md: 'ui-w-32 ui-h-32',
  lg: 'ui-w-40 ui-h-40',
} as const;

/**
 * Componente atom para mostrar un color individual como swatch seleccionable.
 * Usa el componente Icon del sistema de diseño para el indicador de selección.
 */
export const ColorSwatch = ({
  color,
  selected = false,
  onClick,
  size = 'md',
  className,
}: ColorSwatchProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'ui-relative ui-cursor-pointer ui-rounded-control-pill ui-border-2 ui-border-solid ui-transition-all ui-duration-150',
        'hover:ui-scale-110 hover:ui-shadow-02',
        'focus:ui-ring-brand focus:ui-outline-none focus:ui-ring-2 focus:ui-ring-offset-2',
        sizeMap[size],
        selected
          ? 'ui-scale-110 ui-border-brand ui-shadow-02'
          : 'ui-border-transparent hover:ui-border-brand',
        className
      )}
      style={{ backgroundColor: color }}
      aria-label={`Color ${color}`}
      title={color}
    >
      {selected && (
        <div className="ui-absolute ui-inset-0 ui-flex ui-items-center ui-justify-center">
          <Icon name={faCheck} className="ui-drop-shadow-02 ui-text-white" size="sm" />
        </div>
      )}
    </button>
  );
};
